<template>
  <div class="form-group row">
    <div class="card card-fluid shadow-none w-100 mb-0">
      <div class="card-body">
          <div>
            <label >Seleccione comprobantes</label>
            <div class="custom-file">
              <input type="file"
                     class="custom-file-input"
                     id="upload-file"
                     name="upload-file"
                     multiple="true"
                     @change="filesSelected"
                     accept="application/pdf"
                     ref="files">
              <label class="custom-file-label" for="upload-file">
                Seleccionar archivos</label>
            </div>
          </div>
      </div>
      
      <hr v-if="selectedFiles.length">
      
      <div id="uploadList" class="list-group list-group-flush list-group-divider" v-if="selectedFiles.length">
        <div class="list-group-item" v-for="file in selectedFiles"
              :key="file.id">
          <div class="list-group-item-figure">
            <div class="tile tile-img">
              <span class="fas fa-file-pdf fa-lg text-red"></span>
            </div>
          </div>
          <div class="list-group-item-body">
            <div class="media align-items-center">
              <div class="media-body">
                <a target="_blank"
                    href="#" @click.prevent="">{{ file.name }}</a>
                <small v-if="file.size" class="text-muted d-block">{{ fileSize(file) }}</small>
                <small v-else class="text-muted d-block">(Actualmente registrado)</small>
              </div>
              <div class="media-actions">
                <button class="btn btn-sm btn-secondary" type="button" @click="removeFile(file)">Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import { findIndex } from 'lodash'

  export default {
    name: 'FileListInput',
    props: {
      updateFilesInputValue: {
        type: Function,
        default: null,
      },
      selectedFiles: {
        type: Array,
        default: () => ([]),
      },
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters(['user']),
    },
    methods: {
      filesSelected(e) {
        const files = e.target.files
        
        Array.from(files).forEach(file => {
          if(file.type.indexOf('pdf') === -1) {
            AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
              timeout: 10000,
            })
            
            return false
          }

          if (!this.checkFileSize(file)) {
            AlertManager.error(`El tamaño máximo de archivo es de ${ (this.isAdmin() ? 5 : 2) }MB`)
            
            return
          }
          
          if(!this.checkFileType(file)) {
            AlertManager.error('Seleccione un archivo PDF.')
            
            return
          }
          
          this.addFile(file)
        })

        this.updateFilesInputValue(this.selectedFiles)
      },
      addFile(file) {
        const { name, type, size } = file

        $(this.$refs.files).val('')
        
        this.selectedFiles.push({
          id: Math.guid(),
          name,
          type,
          size,
          file,
        })
      },
      fileSize(file) {
        if((file.size / 1024) < 1024) {
          return `${Math.ceil(file.size / 1024)} KB`
        }
        
        return `${Math.ceil(file.size / 1024 / 1024)} MB`
      },
      removeFile(file) {
        const index = findIndex(this.selectedFiles, ['id', file.id])
        
        if(index !== -1) {
          this.selectedFiles.splice(index, 1)
          
          AlertManager.success(`Archivo ${file.name} eliminado satisfactoriamente`)
        }

        this.updateFilesInputValue(this.selectedFiles)
      },
      checkFileSize(file) {
        let maxFileSize = (this.isAdmin() ? 5 : 2) * 1024 * 1024 // 2MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
  }
</script>
